// DailyMultiActive > DailyMultiActive
import React from 'react'
import UxGrid from '../UxGrid'
import Scale from '../ScaleData'
import { convertFrom24To12 } from '../utils/Time'
import { padZero } from '../utils/String'
import { DailyMultiActiveProps } from './index'

export const defaultProps = Object.freeze({
	use24: false
})

export default class DailyMultiActive<T extends object> extends React.PureComponent<DailyMultiActiveProps<T>> {
	static readonly defaultProps = defaultProps

	labelConversion = (ix: number) => {
		const { use24 } = this.props

		let hour = ix / 2
		let min = 0
		let period = ''

		if (!use24) {
			const timeObj = convertFrom24To12(hour)

			hour = timeObj.hour
			min = timeObj.minute
			period = timeObj.period
		}

		const time = !use24
			? min > 0 ? `${hour}:${padZero(min)}${period.substring(0, 1)}` : `${hour}${period.substring(0, 1)}`
			: `${hour}:${padZero(min)}`

		return time
	}

	render() {
		return <UxGrid<T> scale={new Scale(0, 48, 1)} labelConversion={this.labelConversion} {...this.props} />
	}
}
